import React from 'react';
import { HeroSecondary } from './components/HeroSecondary/HeroSecondary';
import { Advantages } from './components/Advantages/Advantages';
import { ScrollVideo } from './components/ScrollVideo/ScrollVideo';
import { Feature } from './components/Feature/Feature';
import { Concepts } from './components/Concepts/Concepts';
import { Peculiarities } from './components/Peculiarities/Peculiarities';
import { BigInfo } from './components/BigInfo/BigInfo';
// import { BgVideo } from './components/BgVideo/BgVideo';
import { Map } from './components/Map/Map';
import { HalfSlider } from './components/HalfSlider/HalfSlider';
import { Infrastructure } from './components/Infrastructure/Infrastructure';
import { TabSlider } from './components/TabSlider/TabSlider';
import { Landscaping } from './components/Landscaping/Landscaping';
import { Layouts } from './components/Layouts/Layouts';
import { Comfort } from './components/Comfort/Comfort';
import { Finishing } from './components/Finishing/Finishing';
import { Features } from './components/Features/Features';
import { App } from './components/App/App';
import { Gallery } from './components/Gallery/Gallery';
import { About } from './components/About/About';
import { Presentation } from './components/Presentation/Presentation';
import { MapSlim } from './components/MapSlim/MapSlim';
import { Viewing } from './components/Viewing/Viewing';
import { Preloader } from './components/Preloader/Preloader';
import './assets/fonts/fonts.css';
import './styles/landing.sass';

export function LandingPage() {
  return (
    <main className="prichal-page">
      <Preloader />
      <HeroSecondary clouds={false} />
      <Advantages />
      <ScrollVideo />
      <Feature />
      <Concepts />
      <Peculiarities />
      <BigInfo />
      {/*<BgVideo />*/}
      <Map />
      <HalfSlider />
      <Infrastructure />
      <TabSlider />
      <Landscaping />
      <Layouts />
      <Comfort />
      <Features />
      <Finishing />
      <Presentation />
      <App />
      <Gallery />
      <About />
      <Viewing />
      <MapSlim />
      <HeroSecondary clouds={true} />
      <section id="about" />
    </main>
  );
}
